import styled from 'styled-components';

const StyledPdpContainer = styled.div`
  max-width: 600px;
  font-family: var(--font-family);
`;

export default StyledPdpContainer;
